import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useEffect } from "react";
import { applyConsent, getDefaultDecision } from "../others";
import { getOtherOptionsFromWindow, isCrawler } from "../utils";
import matches from "matches-selector";
import { prepareTcfString } from "../tcf";

function useBannerShortcodeLinks(setContextValue, toggleOverlay) {
  useEffect(function () {
    var eventListener = function eventListener(e) {
      var link = e.target;

      if (matches(link, ".rcb-sc-link")) {
        // Do not allow links for crawlers
        if (isCrawler()) {
          alert(getOtherOptionsFromWindow().bannerI18n.crawlerLinkAlert);
        } else {
          var type = link.getAttribute("href").slice(1);

          if (type === "revoke") {
            setContextValue(function (state) {
              var tcf = state.tcf;

              _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var buttonClicked, tcfString, successMessage;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        // Do not rely on current state of `groups` because it can be altered through history change
                        buttonClicked = "shortcode_revoke"; // TCF compatibility: revoke TCF string

                        if (process.env.IS_TCF === "1" && tcf !== null && tcf !== void 0 && tcf.model) {
                          tcfString = prepareTcfString(tcf.model, buttonClicked);
                        }

                        _context.next = 4;
                        return applyConsent({
                          consent: {
                            groups: getDefaultDecision(true)
                          },
                          buttonClicked: buttonClicked,
                          tcfString: tcfString
                        });

                      case 4:
                        // Always reload (always wait 2s to ensure opt-out scripts are exeucted)
                        successMessage = link.getAttribute("data-success-message");
                        successMessage && alert(successMessage);
                        setTimeout(function () {
                          window.location.reload();
                        }, 2000);

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }))(); // Do not change anything


              return state;
            });
          } else {
            setContextValue(function (state) {
              return _objectSpread(_objectSpread({}, state), {}, {
                activeAction: type,
                individualPrivacyOpen: true
              }, toggleOverlay(state, true));
            });
          }
        }

        e.preventDefault();
      }
    };

    document.addEventListener("click", eventListener);
    return function () {
      document.removeEventListener("click", eventListener);
    };
  }, []);
}

export { useBannerShortcodeLinks };